"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTodayDate = void 0;
/**
 * Get todays date, without the time part
 * @public
 *
 * @returns The current date at 00:00:00.000 UTC
 *
 * @example
 * ```ts
 * const today = getTodayDate();
 * console.log(today);
 * // -> 2020-05-12T00:00:00.000Z
 * ```
 */
function getTodayDate() {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}
exports.getTodayDate = getTodayDate;
//# sourceMappingURL=get-today-date.js.map